import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function BasicStar({
  outline,
  ...props
}: IconProps & { outline?: boolean }): JSX.Element {
  if (outline) {
    return <BasicStar.Outline {...props} />;
  }
  return <BasicStar.Filled {...props} />;
}

BasicStar.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1385 3.8879C10.8712 2.29941 13.1288 2.29941 13.8615 3.8879L15.4798 7.39625C15.5599 7.56994 15.7245 7.68953 15.9144 7.71205L19.7511 8.16696C21.4883 8.37292 22.1859 10.5201 20.9016 11.7078L18.065 14.331C17.9246 14.4608 17.8617 14.6543 17.899 14.8419L18.652 18.6314C18.9929 20.3472 17.1664 21.6742 15.64 20.8198L12.2686 18.9326C12.1017 18.8392 11.8983 18.8392 11.7314 18.9326L8.36002 20.8198C6.83357 21.6742 5.0071 20.3472 5.34802 18.6314L6.10099 14.8419C6.13827 14.6543 6.07539 14.4608 5.93496 14.331L3.09839 11.7078C1.81406 10.5201 2.51171 8.37292 4.24887 8.16696L8.08557 7.71205C8.27552 7.68953 8.44013 7.56994 8.52024 7.39625L10.1385 3.8879ZM12.4994 4.51617C12.3029 4.08999 11.6972 4.08999 11.5006 4.51617L9.88233 8.02451C9.58371 8.67192 8.97018 9.11768 8.26218 9.20162L4.42548 9.65652C3.95941 9.71178 3.77224 10.2878 4.11682 10.6065L6.95339 13.2297C7.47683 13.7137 7.71117 14.435 7.57223 15.1343L6.81926 18.9238C6.72779 19.3841 7.21782 19.7401 7.62736 19.5109L10.9987 17.6238C11.6208 17.2755 12.3792 17.2755 13.0013 17.6238L16.3727 19.5109C16.7822 19.7401 17.2722 19.3841 17.1807 18.9238L16.4278 15.1343C16.2888 14.435 16.5232 13.7137 17.0466 13.2297L19.8832 10.6065C20.2278 10.2878 20.0406 9.71178 19.5745 9.65652L15.7378 9.20162C15.0298 9.11768 14.4163 8.67192 14.1177 8.02451L12.4994 4.51617Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

// Our solid icon is different than our filled icon.
// This is just another variation of the star icon.
BasicStar.Filled = function Filled({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Filled`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1385 3.8879C10.8712 2.29941 13.1288 2.29941 13.8615 3.8879L15.4798 7.39625C15.5599 7.56994 15.7245 7.68953 15.9144 7.71205L19.7511 8.16696C21.4883 8.37292 22.1859 10.5201 20.9016 11.7078L18.065 14.331C17.9246 14.4608 17.8617 14.6543 17.899 14.8419L18.652 18.6314C18.9929 20.3472 17.1664 21.6742 15.64 20.8198L12.2686 18.9326C12.1017 18.8392 11.8983 18.8392 11.7314 18.9326L8.36002 20.8198C6.83357 21.6742 5.0071 20.3472 5.34802 18.6314L6.10099 14.8419C6.13827 14.6543 6.07539 14.4608 5.93496 14.331L3.09839 11.7078C1.81406 10.5201 2.51171 8.37292 4.24887 8.16696L8.08557 7.71205C8.27552 7.68953 8.44013 7.56994 8.52024 7.39625L10.1385 3.8879Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
